<script setup lang="ts">
import type { FormKitFrameworkContext } from "@formkit/core";
import type { PropType } from "vue";

import { computed } from "vue";

import { DATA_TEST_IDS } from "@/constants/data-test-ids";
import { useTypedIntl } from "@/locales/intl";

import Dropdown from "primevue/dropdown";

export interface FormKitPrimeMinYearDropdownProps {
  placeholder?: string;
  name?: string;
  disabled?: boolean;
  optional?: boolean;
  minYear?: number;
}

const props = defineProps({
  context: {
    type: Object as PropType<FormKitFrameworkContext & FormKitPrimeMinYearDropdownProps>,
  },
});

const { t, k } = useTypedIntl();

const selectedYear = computed({
  get: () => props.context?._value,
  set: (newValue) => {
    props.context?.node.input(newValue);
  },
});

const years = computed(() => {
  const currentYear = new Date().getFullYear();
  const minYear = props.context?.minYear ?? new Date().getFullYear() - 3;
  return Array.from({ length: currentYear - minYear + 1 }, (_, index) => {
    return {
      year: minYear + index,
      desc: index === 0 ? t(k.global.beforeNumber({ number: minYear + 1 })) : minYear + index,
    };
  });
});
</script>

<template>
  <Dropdown
    v-model="selectedYear"
    :options="years"
    :name="props.context?.name"
    :disabled="props.context?.disabled"
    option-label="desc"
    option-value="year"
    :placeholder="props.context?.placeholder"
    class="w-full"
    v-bind="$attrs"
    :data-test-id="DATA_TEST_IDS.components.minYearDropdown.input()"
  />
</template>

<style scoped></style>
